var map = {
	"./Black_Account_Icons-01.png": 680,
	"./Black_Account_Icons-02.png": 681,
	"./Black_Account_Icons-03.png": 682,
	"./Black_Account_Icons-04.png": 683,
	"./Black_Account_Icons-05.png": 684,
	"./Black_Account_Icons-06.png": 685,
	"./Black_Account_Icons-07.png": 686,
	"./Black_Account_Icons-08.png": 687,
	"./Black_Account_Icons-09.png": 688,
	"./Black_Account_Icons-10.png": 689,
	"./Black_Account_Icons-11.png": 690,
	"./Black_Account_Icons-12.png": 691,
	"./Black_Account_Icons-13.png": 692,
	"./Black_Account_Icons-14.png": 693,
	"./FilePresentOutlined.svg": 694,
	"./accuracyAccountsDemo_downloadMT4.jpg": 695,
	"./accuracyAccountsReal_downloadMT4.jpg": 696,
	"./alert@2x.svg": 697,
	"./apple-brands.svg": 698,
	"./arrow_up_from_box.svg": 699,
	"./bankWire.svg": 700,
	"./bdswissDemo_downloadMT4.png": 701,
	"./bdswissGlobalDemo_downloadMT4.png": 702,
	"./bdswissGlobalReal02_downloadMT4.png": 703,
	"./bdswissGlobalReal03_downloadMT4.png": 704,
	"./bdswissGlobalReal04_downloadMT4.png": 705,
	"./bdswissGlobalReal05_downloadMT4.png": 706,
	"./bdswissGlobalReal_downloadMT4.png": 707,
	"./bdswissGlobalReal_downloadMT5.png": 708,
	"./bdswissReal02_downloadMT4.png": 709,
	"./bdswissReal03_downloadMT4.png": 710,
	"./bdswissReal04_downloadMT4.png": 711,
	"./bdswissReal05_downloadMT4.png": 712,
	"./bdswissReal_downloadMT4.png": 713,
	"./bdswissReal_downloadMT5.png": 714,
	"./bdswissSCDemo_downloadMT4.png": 715,
	"./bdswissSCReal01_downloadMT4.png": 716,
	"./bdswissSCReal02_downloadMT4.png": 717,
	"./bdswissSCReal03_downloadMT4.png": 718,
	"./bdswissSCReal04_downloadMT4.png": 719,
	"./bdswissSCReal05_downloadMT4.png": 720,
	"./bdswiss_grey.png": 721,
	"./bdswiss_white.png": 722,
	"./bg-image-affiliate.png": 723,
	"./bitwallet-bdSwiss-dark.svg": 724,
	"./bitwallet-bdSwiss-light.svg": 725,
	"./bitwallet-swissMarkets-dark.svg": 726,
	"./bitwallet-swissMarkets-light.svg": 727,
	"./card.svg": 728,
	"./check_circle.png": 729,
	"./chf.png": 730,
	"./competitions.png": 731,
	"./complimentary@2x.svg": 732,
	"./control-radio-off.png": 733,
	"./control-radio-on.png": 734,
	"./crypto.svg": 735,
	"./cvv.svg": 736,
	"./deposit-card.svg": 737,
	"./diners.png": 738,
	"./dkk.png": 739,
	"./document-upload-failure-dark.png": 740,
	"./document-upload-failure-light.png": 741,
	"./document-upload-success-black.png": 742,
	"./document-upload-success-dark.png": 743,
	"./document-upload-success-light.png": 744,
	"./documents-empty-dark.png": 745,
	"./documents-empty-light.png": 746,
	"./downloadPdf-light.png": 747,
	"./downloadPdf.png": 748,
	"./dpWorldTourChampionship-dark.svg": 749,
	"./dpWorldTourChampionship-light.svg": 750,
	"./eWallet.svg": 751,
	"./eur.png": 752,
	"./exp-date.svg": 753,
	"./fees@2x.svg": 754,
	"./filterIcon.png": 755,
	"./gbp.png": 756,
	"./icon-add-account.svg": 450,
	"./icon-appstore@2x.png": 757,
	"./icon-arrow-right-dark.png": 758,
	"./icon-arrow-right-light.png": 759,
	"./icon-bank-wire.svg": 760,
	"./icon-checkbox.svg": 761,
	"./icon-close-dark.svg": 762,
	"./icon-close-light.svg": 763,
	"./icon-close.png": 764,
	"./icon-contact-callback@2x.png": 765,
	"./icon-contact-callback@2x.svg": 766,
	"./icon-contact-chat@2x.png": 451,
	"./icon-contact-chat@2x.svg": 452,
	"./icon-contact-email@2x.png": 767,
	"./icon-contact-email@2x.svg": 768,
	"./icon-contact-faqs@2x.png": 769,
	"./icon-contact-faqs@2x.svg": 770,
	"./icon-contact-oneOnOneSession@2x.png": 771,
	"./icon-contact-telegram@2x.png": 772,
	"./icon-contact-whatsapp@2x.png": 773,
	"./icon-crypto.svg": 774,
	"./icon-document.svg": 775,
	"./icon-facebook@2x.png": 776,
	"./icon-google-play@2x.png": 777,
	"./icon-notification.svg": 778,
	"./icon-profile-big.svg": 779,
	"./icon-profile.svg": 780,
	"./icon-spoa.svg": 781,
	"./icon-swapFree.svg": 782,
	"./icon-telegram@2x.png": 783,
	"./icon-twitter@2x.png": 784,
	"./icon_accounts_dashboard.svg": 785,
	"./icon_logout_dashboard.svg": 786,
	"./icon_notification_dashboard.svg": 787,
	"./icon_profilesettings_dashboard.svg": 788,
	"./icon_support_dashboard.svg": 789,
	"./icon_transaction_dashboard.svg": 790,
	"./jcb.png": 791,
	"./knet-logo.png": 453,
	"./languages.png": 792,
	"./limit-failure-dark.png": 793,
	"./limit-failure-light.png": 794,
	"./logo-accuracy.png": 795,
	"./logo-bdstrading-white.svg": 796,
	"./logo-bdstrading.svg": 797,
	"./logo-bdswiss-white.svg": 798,
	"./logo-bdswiss.png": 799,
	"./logo-bdswiss.svg": 800,
	"./logo-equityflow-black.png": 801,
	"./logo-equityflow-white.png": 802,
	"./logo-facebook.png": 803,
	"./logo-google.png": 804,
	"./logo-google.svg": 805,
	"./logo-lydian-black.png": 806,
	"./logo-lydian-black.svg": 807,
	"./logo-lydian-white.svg": 808,
	"./logo-regalx-white.png": 809,
	"./logo-regalx.png": 810,
	"./logo-skyground-black.svg": 811,
	"./logo-skyground-white.svg": 812,
	"./logo-swissmarkets-white.svg": 813,
	"./logo-swissmarkets.png": 814,
	"./logo-swissmarkets.svg": 815,
	"./logo-tauromarkets-black.png": 816,
	"./logo-tauromarkets-white.png": 817,
	"./logo-tauromarkets-white2.png": 818,
	"./logo-tauromarkets-white2.svg": 819,
	"./logo-valutamarkets.png": 820,
	"./maestro.png": 821,
	"./mastercard.png": 822,
	"./mastercard_logo_icon.svg": 823,
	"./mercedesCup-dark.svg": 824,
	"./mercedesCup-light.svg": 825,
	"./nationalIdBR.png": 826,
	"./nationalIdES.jpg": 827,
	"./nationalIdIT.jpg": 828,
	"./nationalIdZA.png": 829,
	"./no-trades-dark.png": 830,
	"./no-trades-light.png": 831,
	"./no-trading-signals-dark.png": 832,
	"./nok.png": 833,
	"./notifications-empty-dark.png": 834,
	"./notifications-empty-light.png": 835,
	"./onlineBanking.svg": 836,
	"./onlineDeposit.svg": 837,
	"./page-not-found-dark.svg": 454,
	"./page-not-found-light.svg": 455,
	"./payment-failure-dark.png": 838,
	"./payment-failure-light.png": 839,
	"./payment-pending-dark.png": 840,
	"./payment-pending-light.png": 841,
	"./payment-success-dark.png": 842,
	"./payment-success-light.png": 843,
	"./payments-history-empty-dark.png": 844,
	"./payments-history-empty-light.png": 845,
	"./phone_verification.png": 846,
	"./place1-leadership.png": 847,
	"./place2-leadership.png": 848,
	"./place3-leadership.png": 849,
	"./pln.png": 850,
	"./pof-bankStatement.png": 851,
	"./pof-bankStatementPOF.png": 852,
	"./pof-card-back.png": 853,
	"./pof-card.png": 854,
	"./pof-cardStatement.png": 855,
	"./pof-other.png": 856,
	"./pof-proofOfResidence.png": 857,
	"./pof-swiftCopyPaymentAdvice.png": 858,
	"./pof-virtualCard.png": 859,
	"./poi-document.png": 860,
	"./poi-drivingLicense-back.png": 861,
	"./poi-drivingLicense.png": 862,
	"./poi-id-back.png": 863,
	"./poi-id.png": 864,
	"./poi-passport.png": 865,
	"./por-bankStatementPOR.png": 866,
	"./por-document.png": 867,
	"./por-proofOfResidence.png": 868,
	"./por-utilityBill.png": 869,
	"./priority@2x.svg": 870,
	"./referAndEarn.png": 871,
	"./regalxDemo_downloadMT4.png": 872,
	"./regalxReal01_downloadMT4.png": 873,
	"./regalxReal02_downloadMT4.png": 874,
	"./regalxReal03_downloadMT4.png": 875,
	"./regalxReal04_downloadMT4.png": 876,
	"./regalxReal05_downloadMT4.png": 877,
	"./register-referral-light.png": 878,
	"./sek.png": 879,
	"./sign-up.png": 880,
	"./spaceship.png": 881,
	"./spreads@2x.svg": 882,
	"./support@2x.svg": 883,
	"./swissmarketsDemo_downloadMT4.png": 884,
	"./swissmarketsReal02_downloadMT4.png": 885,
	"./swissmarketsReal_downloadMT4.png": 886,
	"./tauroDemo01DownloadMT4.jpg": 887,
	"./tauroReal01DownloadMT4.jpg": 888,
	"./technicalIndicator-ebook.png": 889,
	"./technicalIndicatorItem.svg": 890,
	"./telegram-dark.png": 891,
	"./telegram.png": 892,
	"./trading-alerts-tradingAlerts-dark.png": 893,
	"./trading-alerts-tradingAlerts-light.png": 894,
	"./tradingPsychology-ebook.png": 895,
	"./tradingPsychologyItem.svg": 896,
	"./transfer-external.svg": 897,
	"./transfer-internal.svg": 898,
	"./transfer-spoa.svg": 899,
	"./upload-bankStatement-error.png": 900,
	"./upload-bankStatement-success.png": 901,
	"./upload-bankStatement.png": 902,
	"./upload-document-dark.png": 903,
	"./upload-document-light.png": 904,
	"./upload-generic-error.png": 905,
	"./upload-generic-success.png": 906,
	"./upload-generic.png": 907,
	"./upload-pof-back-card-error.png": 908,
	"./upload-pof-back-card-success.png": 909,
	"./upload-pof-back-card.png": 910,
	"./upload-pof-front-card-error.png": 911,
	"./upload-pof-front-card-success.png": 912,
	"./upload-pof-front-card.png": 913,
	"./upload-poi-back-drivingLicense-error.png": 914,
	"./upload-poi-back-drivingLicense-success.png": 915,
	"./upload-poi-back-drivingLicense.png": 916,
	"./upload-poi-back-error.png": 917,
	"./upload-poi-back-success.png": 918,
	"./upload-poi-back.png": 919,
	"./upload-poi-front-drivingLicense-error.png": 920,
	"./upload-poi-front-drivingLicense-success.png": 921,
	"./upload-poi-front-drivingLicense.png": 922,
	"./upload-poi-front-error.png": 923,
	"./upload-poi-front-success.png": 924,
	"./upload-poi-front.png": 925,
	"./upload-por-front-error.png": 926,
	"./upload-por-front-proofOfResidence-error.png": 927,
	"./upload-por-front-proofOfResidence-success.png": 928,
	"./upload-por-front-proofOfResidence.png": 929,
	"./upload-por-front-success.png": 930,
	"./upload-por-front-utilityBill-error.png": 931,
	"./upload-por-front-utilityBill-success.png": 932,
	"./upload-por-front-utilityBill.png": 933,
	"./upload-por-front.png": 934,
	"./usd.png": 935,
	"./visa.png": 936,
	"./visa_logo_icon.svg": 937,
	"./vps-enter-credentials.png": 938,
	"./vps-remote-desktop-windows.png": 939,
	"./vps-remote-desktop.png": 940,
	"./waiting-list-skip-dark.png": 941,
	"./waiting-list-skip.png": 942,
	"./windows-brands.svg": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1353;